import { createFileRoute } from '@tanstack/react-router';
import { ComingSoonPage } from '../../components/ComingSoonPage.js';

export const Route = createFileRoute('/studio/')({
  component: () => <ComingSoonPage destination="studio" />,
});
